import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from "@core/scripts/helper/url";
import {useQuery} from "@tanstack/react-query";

const fetchSuggestions = async (query) => {

    const absoluteUrl = URL.toAbsolute('/ajax/search/suggests/');
    const urlWithParam = URL.addUrlParam(absoluteUrl, 'query', query);
    const response = await fetchWithCSRF(urlWithParam, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch suggestions');
    }

    return response.json();
};

const useSuggestions = (searchValue) => {
    return useQuery({
        queryKey: ['search','suggestions', searchValue],
        enabled: searchValue.trim().length > 0,
        placeholderData: (prev) => prev,
        queryFn: () => fetchSuggestions(searchValue),
    });
};
export default useSuggestions;